
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'Logo'
})
export default class Logo extends Vue {
  @Prop({ type: Boolean, default: true }) isShort!: boolean
  @Prop({ type: Boolean, default: false }) isMob!: boolean
}
